import axios from 'axios'
import fileDownload from 'js-file-download'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'

interface CloudStorageProps {
  execUploadFile: (signedUrl: string, file: File) => Promise<Result>
  execDownloadFile: (signedUrl: string, filename: string) => Promise<Result>
  loading: loadStatus
}

// Cloud Storage hooks
export const useCloudStorage = (): CloudStorageProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  // ファイルアップロード
  const execUploadFile = async (signedUrl: string, file: File) => {
    try {
      setLoading(loadStatus.LOADING)
      // "Content-Type": file.type,
      const response = await axios.put(signedUrl, file, {
        headers: {
          'Content-Type': 'application/octet-stream',
        },
      })

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        // console.log("File uploaded successfully.");
        return { success: true }
      }
      setLoading(loadStatus.LOADED)
      // console.log("File upload error.");
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  // ファイルダウンロード
  const execDownloadFile = async (signedUrl: string, filename: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const response = await axios.get(signedUrl, { responseType: 'blob' })
      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        // console.log("File downloaded successfully.");
        fileDownload(response.data, filename)
        return { success: true }
      }
      setLoading(loadStatus.LOADED)
      // console.log("File download error.");
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execUploadFile, execDownloadFile, loading }
}
